import ProjectionsPage from './ProjectionsPage';

export default ProjectionsPage;
